// extracted by mini-css-extract-plugin
export var active = "_6a-c";
export var activeIndicator = "_6a-7";
export var animate = "_6a-b";
export var contentWidthTabs = "_6a-5";
export var disabled = "_6a-d";
export var flat = "_6a-1";
export var fullWidth = "_6a-3";
export var lg = "_6a-a";
export var md = "_6a-9";
export var redoButtonTabGroup = "_6a-0";
export var sm = "_6a-8";
export var tabButton = "_6a-4";
export var tabButtonsContainer = "_6a-2";
export var xs = "_6a-6";